let leaving = false;

/**
 * ページを捨てて別の URL を読み込む。
 *
 * iPhone の Safari は、移動を始めた瞬間に走っていた fetch とチャンクの import を
 * 打ち切って失敗として返す。entry.client の vite:preloadError はそれを古い
 * チャンクと見分けられず読み直し、移動を取り消していた (ログイン直後に
 * ログイン画面へ戻される、2026-09 に受講生から報告)。ここで印を立て、
 * 離れる途中の失敗は読み直さないようにする。
 */
export function navigateAway(url: string) {
  leaving = true;
  // 戻るボタンで bfcache から復帰したとき、または移動が成立せず留まったときは、
  // 古いチャンクの自動回復を戻す
  const reset = () => {
    leaving = false;
  };
  window.addEventListener("pageshow", reset, { once: true });
  setTimeout(reset, 10_000);
  window.location.href = url;
}

export function isNavigatingAway() {
  return leaving;
}
